export default __webpack_public_path__ + "static/media/feature-1.fd271c42.svg";